import Typography from "@material-ui/core/Typography";
import Slider from "@material-ui/core/Slider";
import React from "react";

interface Props {
    classes:any;
    zoom:any;
    setZoom:any;
    rotation:any;
    setRotation:any;
    showCroppedImage:any;
}

const Index = ({classes, zoom, setZoom}:Props) =>{
    return (
        <div className={classes.controls}>
            <div>
                <div className={classes}>
                    <Typography
                        variant="overline"
                        classes={{ root: classes.sliderLabel }}
                    >
                        Zoom
                    </Typography>
                    <Slider
                        value={zoom}
                        min={1}
                        max={3}
                        step={0.1}
                        aria-labelledby="Zoom"
                        classes={{ root: classes.slider }}
                        onChange={(e, zoom) => setZoom(zoom)}
                    />
                </div>
            </div>

        </div>

    )
}

export default Index;